import React from 'react'

export type PageShellProps = React.PropsWithChildren<{
  className?: string
  style?: React.CSSProperties
}>

const BASE_STYLE: React.CSSProperties = {
  padding: 'clamp(24px, 5vw, 32px) clamp(16px, 6vw, 32px) clamp(32px, 8vw, 48px)',
  margin: '0 auto',
  width: '100%',
  maxWidth: '1120px',
  boxSizing: 'border-box'
}

export default function PageShell({ children, className, style }: PageShellProps) {
  const combinedStyle = style ? { ...BASE_STYLE, ...style } : BASE_STYLE
  return (
    <div className={className} style={combinedStyle}>
      {children}
    </div>
  )
}
